import {useEffect, useState} from "react";
import * as Util from "../helpers/util";
import {LockClosedIcon} from "@heroicons/react/24/outline";
import GoogleIcon from '../assets/images/google_icon.png'
import { WEB_URL } from '../settings';


export const Credentials = props => {
    const { showToast } = props;

    const [state, setState] = useState({
        credentials: [],
    })
    const { credentials } = state
    const [isAuthenticating, setIsAuthenticating] = useState(false);

    useEffect(() => {
        if (isAuthenticating) {
            return
        }

        Util.fetch_js(`${WEB_URL}/api/credentials`, {},
            js => {
                setState(prev => ({ ...prev,
                    credentials: js.credentials
                }))
            },
            showToast )
    }, [isAuthenticating]);


    const handleGoogleAuth = () => {
        setIsAuthenticating(true);

        Util.fetch_js(`${WEB_URL}/api/authenticate_google`, {},
            js => {
                showToast('Google Authentication successful', 'success')
                setIsAuthenticating(false);
            },
            err => {
                showToast('Google Authentication failed', err)
                setIsAuthenticating(false);
            })
    }

    return (
        <form>
            <div className="space-y-12">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                    <div>
                        <h2 className="inline-flex items-center text-base/7 font-semibold text-gray-900">
                            <img src={GoogleIcon} alt="Google Icon" className="inline-block ml-2 h-8 w-8" />
                            Google
                        </h2>
                        <p className="mt-1 text-sm/6 text-gray-600">
                            You google auth credentials
                        </p>
                    </div>

                    <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        {credentials.map((cred,idx) => (
                        <div key={`creds_${idx}`} className="sm:col-span-4">
                            <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900">
                                Google Credential {idx + 1}
                            </label>
                            <div className="mt-2">
                                <div className="flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
                                    {cred}
                                </div>
                            </div>
                        </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">
                <button
                    type="submit"
                    className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" >
                    <div className={Util.classNames("cursor-pointer group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-white")}
                         onClick={handleGoogleAuth}>
                        {isAuthenticating &&
                            <>
                                <svg className="animate-spin h-6 w-6 shrink-0 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Authenticating...
                            </>
                        }
                        {!isAuthenticating &&
                            <>
                                <LockClosedIcon
                                    className="h-6 w-6 shrink-0 text-white"
                                    aria-hidden="true"
                                />
                                Create Google Auth
                            </>
                        }
                    </div>
                </button>
            </div>
        </form>
    )
}
